import React, { Fragment, useEffect } from "react";
import { Form, Select, Upload } from "antd";
import { useDispatch } from "react-redux";

import { setFormProps } from "@/reducers/commonSlice";

import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

import IconUploadDocs from "@/components/icons/IconUploadDocs";

import "@/styles/components/document-upload.scss";
import TextArea from "antd/es/input/TextArea";

// const documentTypeOptions = [
//   {
//     value: "passport",
//     label: "Passport",
//   },
//   {
//     value: "driving-licence",
//     label: "Driving Licence",
//   },
// ];

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </>
);

const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const { Option } = Select;
const { Dragger } = Upload;

const UploadDocument = ({ isOpen = false, onSubmit, limit = 1, fileData = {}, fileCategoryId }) => {
  console.log({ limitUploadDocument: limit });
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const categoryIdOfFile = fileData?.fileCategoryId || fileCategoryId;
  // const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const handleFinish = (value) => {
    console.log(value, "value");
    if (typeof onSubmit === "function") {
      form.resetFields();
      onSubmit({ ...value, fileid: fileData.id });
    }
  };

  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  let fileList = [];
  if (Object.keys(fileData)?.length) {
    fileList = [
      {
        uid: "-1",
        name: fileData?.fileName,
        status: "done",
        url: fileData.signedUrl,
        thumbUrl: fileData.signedUrl,
      },
    ];
  }
  console.log(fileList);
  // const fetchDocument = () => {
  //   getFileCategories()
  //     .then((res) => {
  //       const data = res.map((x) => {
  //         return {
  //           value: x.id,
  //           label: x.name,
  //         };
  //       });
  //       setDocumentTypeOptions(data);
  //     })
  //     .catch((err) => console.log(err));
  // };
  // useEffect(() => {
  //   fetchDocument();
  // }, []);

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
      form.resetFields(["file"]);
      fileList = [];
      dispatch(setFormProps({}));
    }
  }, [isOpen]);

  return (
    <Fragment>
      <ModalComponent isOpen={isOpen}>
        <div className="document-upload-form">
          <Form
            name="document"
            form={form}
            initialValues={{ remember: false }}
            layout="vertical"
            size="small"
            onFinish={handleFinish}
            requiredMark={customizeRequiredMark}
          >
            <Form.Item
              name="file"
              getValueFromEvent={getFile}
              rules={[
                {
                  required: true,
                  message: "Please select document",
                },
                {
                  // show file size error message
                  validator: (rule, value) => {
                    if (value && value[0]?.size) {
                      const maxFileSize =
                        categoryIdOfFile === 6 ? 100 * 1024 * 1024 : 5 * 1024 * 1024;
                      const maxSizeLabel = categoryIdOfFile === 6 ? "100MB" : "5MB";
                      const fileSize = value[0].size;
                      const isSizeValid = fileSize <= maxFileSize;
                      if (!isSizeValid) {
                        return Promise.reject(`File must be smaller than ${maxSizeLabel}!`);
                      }
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Dragger
                multiple={true}
                maxCount={limit}
                beforeUpload={() => false}
                accept={
                  categoryIdOfFile === 6
                    ? ".mp4, .mov, .avi, .mkv, .webm, .flv"
                    : ".pdf, .doc, .docx, .xls, .xlsx , .csv, .jpg, .jpeg, .png, .txt, .heic"
                }
                defaultFileList={[...fileList]}
              >
                <p className="ant-upload-drag-icon">
                  <IconUploadDocs />
                </p>
                <p className="ant-upload-text">
                  Tap here to upload the <br /> document.
                </p>
              </Dragger>
            </Form.Item>
            <Form.Item
              label="Add Comments"
              name="documentName"
              className=""
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter document name!",
              //   },
              // ]}
            >
              <TextArea
                autoSize={{ minRows: 4, maxRows: 7 }}
                style={{
                  padding: "10px",
                }}
                placeholder="Enter your comment..."
              />
            </Form.Item>
            {/* <Form.Item
              label="Document Type"
              name="documentType"
              rules={[
                {
                  required: true,
                  message: "Please select document type",
                },
              ]}
            >
              <Select
                virtual={false}
                showSearch
                placeholder="Select a document type"
                className="w-100"
                filterOption={filterOption}
              >
                {documentTypeOptions.map((type) => {
                  return (
                    <Option
                      key={type.value}
                      value={type.value}
                      label={type.label}
                    >
                      <div>{type.label}</div>
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
            <Form.Item>
              <div className="button">
                <ButtonComponent
                  label="Upload Document"
                  varient="primary"
                  htmlType="submit"
                  className="w-100"
                />
              </div>
            </Form.Item>
          </Form>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default UploadDocument;
